<template>
  <div>
    <h1>Escala Customer</h1>
    <p>
      Customer ID: <strong>{{ customerId }}</strong>
    </p>
    <button class="btn btn-info-button" @click="sendCustomerToEscala">
      Send customer to escala
    </button>
  </div>
</template>
<script>
import { sendCustomerToEscala as sendCustomerToEscalaApi } from "@/api/store/EscalaService";
export default {
  name: "EscalaCustomer",
  props: {
    customerId: {
      type: String,
      required: true
    }
  },
  methods: {
    sendCustomerToEscala() {
      sendCustomerToEscalaApi(this.customerId)
        .then(() => {
          this.$toast.success("Customer sent to escala");
        })
        .catch(() => {
          this.$toast.error("Error sending customer to escala");
        });
    }
  }
};
</script>
